var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBiciMecanica(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wxy1bs452a",
    width: "107.2%",
    height: "111.2%",
    x: "-3.6%",
    y: "-5.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "6clojij58b",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.484771 0 0 0 0 0.459066 0 0 0 0 0.437033 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#wxy1bs452a)",
    transform: "translate(-171.000000, -709.000000) translate(20.000000, 578.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#6clojij58b)",
    transform: "translate(17.000000, 131.000000) translate(134.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2001D",
    fillRule: "nonzero",
    d: "M16.5.678c8.725 0 15.822 7.097 15.822 15.822 0 8.725-7.097 15.822-15.822 15.822C7.775 32.322.678 25.225.678 16.5.678 7.775 7.775.678 16.5.678m0-.678C7.391 0 0 7.391 0 16.5S7.391 33 16.5 33 33 25.609 33 16.5 25.609 0 16.5 0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.424658, 8.769863)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.588,
    cy: 10.171,
    r: 3.91,
    stroke: "#E2001D",
    strokeWidth: 0.675
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.263,
    cy: 10.171,
    r: 3.91,
    stroke: "#E2001D",
    strokeWidth: 0.675
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.263,
    cy: 10.171,
    r: 1.017,
    fill: "#E2001D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.588,
    cy: 10.171,
    r: 1.017,
    fill: "#E2001D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.103,
    cy: 10.081,
    r: 1,
    fill: "#E2001D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E2001D",
    strokeLinecap: "round",
    strokeWidth: 0.675,
    d: "M6.645 2.17L8.996 2.17"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.103,
    cy: 10.081,
    r: 1.175,
    stroke: "#E2001D",
    strokeWidth: 0.675
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E2001D",
    strokeLinecap: "round",
    strokeWidth: 0.675,
    d: "M12.951 10.171c0-.95.249-1.83.678-2.6.52-.926 1.311-1.672 2.26-2.146"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E2001D",
    strokeLinecap: "round",
    strokeWidth: 0.675,
    d: "M11.505 0h1.22s.52 0 .724.452c.203.452 4.498 9.064 4.498 9.064M7.888 2.17l1.809 6.735c-.565-2.305-2.645-4-5.109-4C2.622 4.905.904 5.99 0 7.572M8.657 5.447L4.769 9.945M15.234 4.182L10.917 9.109"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E2001D",
    strokeWidth: 0.675,
    d: "M16.975 4.475c.067.113.18.204.316.204h1.921c.204 0 .362-.158.362-.362V1.673c0-.204-.158-.362-.362-.362h-3.21c-.112 0-.225.068-.293.158-.068.09-.068.226-.023.34l1.289 2.666z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiciMecanica);
export default __webpack_public_path__ + "static/media/bici-mecanica.39404ad9.svg";
export { ForwardRef as ReactComponent };